export default "__VITE_ASSET__BvB07j26__"